module.exports = __webpack_public_path__ + "img/designer-creator.43f4fc0d.webp";